import { render } from "./help.vue?vue&type=template&id=b590eb46&ts=true"
import script from "./help.component.ts?vue&type=script&lang=ts"
export * from "./help.component.ts?vue&type=script&lang=ts"

import exportComponent from "D:\\trainsit project\\LTMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__